import { lazy } from "react";

import { redirect } from "react-router-dom";

import { MainLayout } from "@layouts/MainLayout";
import RutaProtegida from "@components/atoms/RutaProtegida";
import { BajoConstruccion } from "@components/BajoConstruccion";

const Usuarios = lazy(() => import("../components/sections/Usuarios"));
const Financieras = lazy(() => import("../components/sections/Financieras"));
const RolesPermisos = lazy(() => import("../components/sections/RolesPermisos"));
const ReglasAdmision = lazy(() => import("../components/sections/ReglasAdmision"));
const CodigosAtribucionV2 = lazy(() => import("../components/sections/CodigosAtribucionV2"));
const ReglasAdmisionFinancieras = lazy(() => import("../components/sections/ReglasAdmisionFinancieras"));

export const adminRoutes = {
    element: <RutaProtegida permissionCodes={["MADMIN"]} />,
    children: [
        {
            Component: MainLayout,
            path: "/admin",
            children: [
                {
                    index: true,
                    Component: Usuarios,
                    loader: ({ request }) => {
                        const url = new URL(request.url);
                        if (/^\/(?:solicitudes|admin)\/$/.test(url.pathname)) {
                            return redirect(url.pathname.replace(/\/+$/, ""));
                        }
                    },
                },
                {
                    Component: RolesPermisos,
                    path: "roles",
                },
                {
                    Component: Financieras,
                    path: "financieras",
                },
                {
                    Component: CodigosAtribucionV2,
                    path: "codigos_atribucion",
                },
                {
                    Component: BajoConstruccion,
                    path: "estructura_atribucion",
                },
                {
                    Component: ReglasAdmision,
                    path: "abortivos_revision",
                },
                {
                    Component: ReglasAdmisionFinancieras,
                    path: "abortivos_revision_financieras",
                },
                {
                    Component: BajoConstruccion,
                    path: "log_actividad",
                },
            ],
        },
    ],
};
